module.exports = __webpack_public_path__ + "static/media/penta_logo_1254.db4588c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/old/penta_logo_1254.png
// module id = 579
// module chunks = 0